import {
    MediaPackProgram,
    MediaProgram,
    WorkflowWorkflowInfo,
} from '@calm/evexia-web-sdk';
import { ProgramProvider } from '@rhg/providers/program';
import { ContextAwareProgram } from './context-aware';

export interface ProgramProps {
    program: MediaProgram;
    packClass: string;
    packProgram?: MediaPackProgram;
    workflow?: WorkflowWorkflowInfo;
    showOverview?: boolean;
}
export function Program({
    program,
    packProgram,
    packClass,
    workflow,
    showOverview,
}: ProgramProps) {
    return (
        <ProgramProvider
            program={program}
            packClass={packClass}
            packProgram={packProgram}
            workflow={workflow}
        >
            <ContextAwareProgram showOverview={showOverview} />
        </ProgramProvider>
    );
}
